exports = module.exports = require("../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{padding:15px;line-height:1.8;color:#303133}h2{margin-top:35px}.container{max-width:760px;margin:0 auto}table tr:nth-child(2n){background-color:#f1f1f1}table th{border-top:1px solid #ebeef5}table td,table th{padding:8px 8px;border-bottom:1px solid #ebeef5}", ""]);

// exports
